import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";
import { __getLoadingScreenCounts } from "./LoadingScreen";

/**
 * Dev-only route-change logger.
 *
 * Prints `previous → next` pathname on every navigation along with the
 * current LoadingScreen mount/unmount counters, so we can confirm at a
 * glance that route transitions don't spawn duplicate bloom overlays.
 *
 * Renders nothing. Stripped from production by `import.meta.env.DEV`.
 */
export default function RouteLogger() {
  const location = useLocation();
  const prevPath = useRef<string | null>(null);

  useEffect(() => {
    if (!import.meta.env.DEV) return;
    const next = location.pathname;
    const prev = prevPath.current;
    const counts = __getLoadingScreenCounts();
    // eslint-disable-next-line no-console
    console.log(
      "%c[Route]",
      "color:#3b82f6; font-weight:bold;",
      `${prev ?? "(initial)"} → ${next}`,
      `· LoadingScreen attempts=${counts.attempts} live=${counts.live}`
    );
    if (counts.live > 1) {
      // eslint-disable-next-line no-console
      console.warn(
        `[Route] ⚠ ${counts.live} LoadingScreen instances live during transition to ${next}`
      );
    }
    prevPath.current = next;
  }, [location.pathname]);

  return null;
}
